<template>
    <div class="error-page">
        <div class="err-icon">
            <img src="@/assets/images/error/icon.png"/>
        </div>
        <p class="err-info">
            {{errorInfo}}
        </p>
        <div></div>
    </div>
</template>

<script>
    export default {
        name: "Error",
        data () {
            return {
                errorInfo: ''
            }
        },
        created () {
            window.document.title = '提示信息';
            if (this.$route.query.e) {
                this.errorInfo = this.$route.query.e;
            } else {
                this.errorInfo = '请求出错，请稍后重试！';
            }
        }
    }
</script>

<style scoped>
    html,body {
        height: 100%;
        width: 100%;
    }

    .error-page {
        height: 100vh;
        width: 100%;
        margin: 0;
        padding-top: 255px;

        background-image: url("../assets/images/error/bg.png");
        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        box-sizing: border-box;

    }

    .err-icon {
        text-align: center;
    }

    .err-icon img {
        width: 374px;
        height: 321px;
        display: inline-block;
        margin-right: 25px;
    }

    .err-info {
        font-family: PingFang SC,Hiragino Sans GB,SimSun,sans-serif;
        font-size: 26px;
        color: #5a5a5a;
        font-weight:400;
        text-align: center;
        padding: 20px 30px;
        box-sizing: border-box;
    }
</style>